export class SearchChangedMessage
{
    public searchValues: string[];

    constructor(searchValues: string[]) {
        this.searchValues = searchValues;
    }
}